// Lucky 15 (lucky15) result — ek ball image + "<X> Run" / "Wicket" text
// (detail.rdesc / winnat, e.g. "4 Run"). Reference: ball-blank.png
// (sprintstaticdata admin/img/balls).
export default function Lucky15Result({ detail }) {
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult">
        <img src="https://wver.sprintstaticdata.com/v230/static/admin/img/balls/ball-blank.png" />
        {' '}
        <span>{(detail?.rdesc || detail?.winnat || '') + ' '}</span>
      </div>
    </div>
  );
}
